import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

import EnhancedMetricsSection from '../Metrics/EnhancedMetricsSection'
import EnhancedMetricsCharts from '../Metrics/EnhancedMetricsCharts'

import styles from './MetricsContent.module.scss'

export const AnalyticsMetricsContentView = ({
  metrics,
  metricsLoading,
  dateRangeStart,
  dateRangeEnd,
  today = new Date().toISOString(),
  planSize,
  planSizeLoading,
  chartData,
  campaignFilter,
  onStartDateChange,
  onEndDateChange,
  isCompactMode = true,
  userId = null,
  userName = null,
  campaignName = null
}) => {
  return (
    <Box className={styles.container}>
      <EnhancedMetricsSection
        key={`${dateRangeStart?.toISOString()}_${dateRangeEnd?.toISOString()}`}
        metrics={metrics}
        metricsLoading={metricsLoading}
        dateRangeStart={dateRangeStart}
        dateRangeEnd={dateRangeEnd}
        today={today}
        planSize={metrics?.planMinutes || planSize}
        planSizeLoading={planSizeLoading}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        userId={userId}
        userName={userName}
        campaignName={campaignName}
        campaignFilter={campaignFilter}
      />
      <EnhancedMetricsCharts
        lineChartData={{
          callsPerDay: chartData?.callsPerDay || [],
          handleTimePerDay: chartData?.handleTimePerDay || [],
          cssPerDay: chartData?.cssPerDay || []
        }}
        pieChartData={{
          dispositionBreakdown: chartData?.dispositionBreakdown || [],
          callDirection: chartData?.callDirection || []
        }}
        campaignFilter={campaignFilter}
        metricsLoading={metricsLoading}
        isCompactMode={isCompactMode}
      />
    </Box>
  )
}

AnalyticsMetricsContentView.propTypes = {
  metrics: PropTypes.object,
  metricsLoading: PropTypes.bool,
  dateRangeStart: PropTypes.object,
  dateRangeEnd: PropTypes.object,
  today: PropTypes.string,
  planSize: PropTypes.number,
  planSizeLoading: PropTypes.bool,
  chartData: PropTypes.shape({
    callsPerDay: PropTypes.array,
    handleTimePerDay: PropTypes.array,
    cssPerDay: PropTypes.array,
    dispositionBreakdown: PropTypes.array,
    callDirection: PropTypes.array
  }),
  campaignFilter: PropTypes.string,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  isCompactMode: PropTypes.bool
}

export const MetricsContent = AnalyticsMetricsContentView

export default MetricsContent
